import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import {computed, nextTick, watch, ref, getCurrentInstance} from 'vue';


const __default__ = {
    name: "ChatPopover"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    visible: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    fixed: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let className = computed(() => {
    return {
        popover: true,
        left: props.left,
        right: props.right,
        top: props.top,
        bottom: props.bottom
    };
});

function onClickAway() {
    emits('update:visible', false)
}

let style = ref<string>();
let instance = getCurrentInstance();

watch(computed(() => props.visible), () => {
    nextTick(() => {
        if (props.visible) {
            if (props.fixed) {
                let rect = (instance.proxy.$el as HTMLElement).getBoundingClientRect();
                style.value = `position: fixed !important; left: ${rect.x}px !important; top: ${rect.y}px !important; right: auto !important; bottom: auto !important; width: ${rect.width}px !important; `
            }
        } else {
            style.value = null;
        }
    });
}, {
    immediate: true
})


return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_ctx.visible)
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(className)),
        style: _normalizeStyle(_unref(style))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 6)), [
        [_directive_click_away, onClickAway]
      ])
    : _createCommentVNode("", true)
}
}

})